export default __webpack_public_path__ + "static/media/feather-cross_ico.36a7f1f7.webp";